import React, { Component } from "react";
import {Modal, Card, Form, Button, Row, Col, Table, Alert, Tab, Tabs, InputGroup, OverlayTrigger, Tooltip, ListGroup, FormLabel, CardBody} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { categoriasDeGraficos } from '../../common/utils';
import Paginacao from '../../common/pagination';
import { FaEdit, FaTrash, FaArrowUp, FaArrowDown } from "react-icons/fa";
import '../ProgramasV2/ProgramasEdit.module.css';

class StatusDoPrograma extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: [],
            statusSelecionado: [{nome: "", slug: '', ativo: "", ordem: '', cor: '#000000', template_whatsapp: "", descricao: '', orientacao: '', tipo: '', menu_adicional_atendimento: '', id: null}],            
            programa_id: this.props.programa_id,
            erroLoadRegistro: '',
            loading: false,
            page_numb: this.props.page_numb || 1,
            page_limit: this.props.page_limit || 50
        }
    }

    componentDidMount() {
        this.carregarStatus();
    }

    carregarStatus = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/status/?programa_id=${this.state.programa_id}&page=${this.state.page_numb}&page_limit=${this.state.page_limit}`)
            .then(response => {
                this.setState({
                    status: {
                        ...response.data,
                        results:response.data.results.map(status => ({
                            id: status.id,
                            nome: status.nome,
                            slug: status.slug,
                            ativo: status.status,
                            menu_adicional_atendimento: status.menu_adicional_atendimento,
                            ordem: status.ordem,
                            template_whatsapp: status.template_whatsapp,
                            cor: status.cor,
                            descricao: status.descricao,
                            orientacao: status.orientacao,
                            tipo: status.tipo
                        }))
                    }
                }, () => {
                    this.props.onStatusChange(this.state.status.results);
                });
            })
            .catch(error => {
                console.error('Erro ao carregar status:', error);
                
                let erro_msg = 'Erro ao carregar status do programa, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
    }

    gerarSlug (nome) {
        return nome
          .toLowerCase() // Converte para minúsculas
          .normalize('NFD') // Normaliza caracteres acentuados
          .replace(/[\u0300-\u036f]/g, '') // Remove acentos
          .replace(/[^a-z0-9-]/g, '-') // Substitui caracteres não alfanuméricos por hífen
          .replace(/--+/g, '-') // Remove hífens duplicados
          .replace(/^-|-$| /g, ''); // Remove hífens no começo ou fim e espaços
      };

    handleStatusChange = (e, fieldName, bool) => {
        if (fieldName === 'nome') {
            this.setState({ statusSelecionado: { ...this.state.statusSelecionado, nome: e.target.value, slug: this.gerarSlug(e.target.value) } });
        //} //else if (fieldName === 'slug'){
        //    status_programa[index] = { ...status_programa[index], [name]: this.gerarSlug(value) };
        } else {
            const { name, value } = e.target;
            if(!value){
                this.setState({ statusSelecionado: { ...this.state.statusSelecionado, [name]: bool } });
            } else {
                this.setState({ statusSelecionado: { ...this.state.statusSelecionado, [name]: value } });
            }
            
        }
    }

    moverStatus = (index, direcao) => {
        let novosStatus = [...this.state.status.results];
        let statusMovido = { ...novosStatus[index] };
    
        if (direcao === 'up' && index > 0) {
            // Troca a etapa atual com a anterior
            novosStatus[index] = novosStatus[index - 1];
            novosStatus[index - 1] = statusMovido;
            // Atualiza a ordem (index baseado em 1 para a ordem)
            novosStatus[index].ordem = index + 1;
            novosStatus[index - 1].ordem = index;
        } else if (direcao === 'down' && index < novosStatus.length - 1) {
            // Troca a etapa atual com a seguinte
            novosStatus[index] = novosStatus[index + 1];
            novosStatus[index + 1] = statusMovido;
            // Atualiza a ordem
            novosStatus[index].ordem = index + 1;
            novosStatus[index + 1].ordem = index + 2;
        }
    
        // Atualiza o estado
        this.setState({ status: { ...this.state.status, results: novosStatus } }, () => {
            // Salva a etapa movida com a nova ordem
            this.handleSalvarStatus(index + (direcao === 'down' ? 1 : -1));
            // Salva a etapa que foi substituída pela movida, para atualizar sua ordem
            this.handleSalvarStatus(index);
        });
    };

    handleSalvarStatus = async (index = null) => {
        const formData = new FormData();
        const status = index !== null ? this.state.status.results[index] : this.state.statusSelecionado;
        let url = '';
        let metodo = '';

        if(index !== null){
            url = `/programas/status/${this.state.status.results[index].id}/`;    
            metodo = 'put';
        } else {
            url = status.id ? `/programas/status/${status.id}/` : '/programas/status/';
            metodo = status.id ? 'put' : 'post';
        }

        const dadosStatus = {
            nome: status.nome,
            slug: status.slug,
            status: status.ativo,
            menu_adicional_atendimento: status.menu_adicional_atendimento || '',
            template_whatsapp: status.template_whatsapp || '',
            cor: status.cor || "",
            descricao: status.descricao || '',
            orientacao: status.orientacao || '',
            tipo: status.tipo,
            programa_id: this.state.programa_id
        };

        if(index){
            dadosStatus['ordem'] = index + 1;
        } else {
            dadosStatus['ordem'] = status.ordem || this.state.status.results.length + 1;
        }
        api({
            method: metodo,
            url: url,
            data: dadosStatus,
        })
        .then(response => {
            
            if(index == null){
                const MySwal = withReactContent(Swal)
                const textSwal = (this.state.statusSelecionado.id) ? 'Status atualizado com sucesso' : 'Status cadastrado com sucesso';

                MySwal.fire({
                    title: <p>{textSwal}</p>,
                    icon: 'success',
                    showCloseButton: true,
                })

                this.carregarStatus();
                this.handleCloseModalStatus();
            }
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o status, verifique os campos e tente novamente';         
            let content = '';   

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'nome') {
                        content += `<br>&bull; Nome: ${value}`;
                    }
                    if(key == 'slug') {
                        content += `<br>&bull; Slug: ${value}`;
                    }
                    if(key == 'programa_id') {
                        content += `<br>&bull; Id do programa: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    }

    removerStatus = (status) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover status?',
            text: "Tem certeza que deseja remover o status " + status.nome + "?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                if (status.id) {
                    api({
                        method: 'delete',
                        url: `/programas/status/${status.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Status removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.carregarStatus();
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o status, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        status: prevState.status.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O status foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    handleShowModalStatus = (status = []) => {
        this.setState({ showModalStatus: true, statusSelecionado: status });
    }

    handleCloseModalStatus = () => {
        this.setState({ showModalStatus: false, statusSelecionado: []});
    }

    onClickPaginaStatus = (num_page) => {
        this.setState({
            loading: true,
            page_numb: num_page
        }, () => {
            this.carregarStatus(num_page)
        });
    };


    render() {
        return (
            <>
            <Card className="cardDestaque mt-4">
                <Card.Body>                   
                    <Row className="align-items-center mb-3">
                        <Col sm={6} lg={6}>
                            <h6><strong>Status do Programa</strong></h6>
                        </Col>
                        <Col sm={6} xs={6} className="text-end">                       
                            <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalStatus()}>
                                {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Adicionar Status'}                                       
                            </Button>
                        </Col>
                    </Row>
                    {('results' in this.state.status && this.state.status.results.length > 0) ? (
                        <Row>
                            <Col sm={12} lg={12}>
                                <Table responsive className="custom-table">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Nome</th>
                                            <th>Slug</th>
                                            <th>Ativo</th>
                                            <th>Ordem</th>
                                            <th>Opções</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.status.results.map((status, index) => ( 
                                            <tr key={index}>
                                                <td className="bg-id">#{status.id}</td>
                                                <td className="td-border">{status.nome}</td>
                                                <td className="td-border">{status.slug}</td>
                                                <td className="td-border">{status.ativo}</td>
                                                <td className="td-border">{status.ordem}
                                                    {status.id && index > 0 && (
                                                        <Button variant="outline-primary" className="btn-sm me-2" onClick={() => this.moverStatus(index, 'up')}><FaArrowUp /></Button>
                                                    )}
                                                    {status.id && index < this.state.status.results.length - 1 && (
                                                        <Button variant="outline-primary" className="btn-sm" onClick={() => this.moverStatus(index, 'down')}><FaArrowDown /></Button>
                                                    )}
                                                </td>
                                                <td>
                                                    <Button variant="secondary" size="sm" className="me-2" onClick={() => this.handleShowModalStatus(status)}>
                                                        <FaEdit /> Editar
                                                    </Button>  
                                                    <Button variant="danger" size="sm" className="me-2" onClick={() => this.removerStatus(status)}>
                                                        <FaTrash /> Remover
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                    {'results' in this.state.status && this.state.status.results.length > 0 && (
                                        <Paginacao dados={this.state.status} limit={this.state.page_limit} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPaginaStatus} />
                                    )}
                            </Col>
                        </Row>   
                    ) : (
                        <p>Nenhum status cadastrado até o momento</p>
                    )}
                            
                </Card.Body>                
            </Card>

            <Modal show={this.state.showModalStatus} onHide={this.handleCloseModalStatus} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {this.state.statusSelecionado.id ? 'Editar Status #' + this.state.statusSelecionado.id : 'Adicionar Status'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <h4>Status</h4>
                            <div className="row-list">
                                <Row>                                                
                                    <Col sm={4} xs={12}>
                                        <Form.Group>
                                            <Form.Label>Nome</Form.Label>   
                                            <Form.Control 
                                                type="text"                                                             
                                                name="nome"
                                                value={this.state.statusSelecionado.nome} 
                                                onChange={(e) => this.handleStatusChange(e, "nome")}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4} xs={12}>
                                        <Form.Group>
                                            <Form.Label>Slug</Form.Label>   
                                            <Form.Control 
                                                type="text"                                                             
                                                name="slug"
                                                value={this.state.statusSelecionado.slug} 
                                                onChange={(e) => this.handleStatusChange(e, "slug")}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={2} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Ativo / Inativo</Form.Label>
                                            <div>
                                                <Button name="ativo"
                                                    variant={this.state.statusSelecionado.ativo ? "success" : "outline-secondary"}
                                                    onClick={(e) => this.handleStatusChange(e, "ativo", true)}>
                                                    Ativo
                                                </Button>
                                                {' '}
                                                <Button name="ativo"
                                                    variant={!this.state.statusSelecionado.ativo ? "danger" : "outline-secondary"}
                                                    onClick={(e) => this.handleStatusChange(e, "ativo", false)}>
                                                    Inativo
                                                </Button>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col sm={2} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Adicionar como menu lateral</Form.Label>
                                            <Form.Control 
                                                type="text"                                                             
                                                name="menu_adicional_atendimento"
                                                value={this.state.statusSelecionado.menu_adicional_atendimento} 
                                                onChange={(e) => this.handleStatusChange(e, "menu_adicional_atendimento")}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3} xs={12}>
                                        <Form.Group>
                                            <Form.Label>Ordem</Form.Label>   
                                            <Form.Control 
                                                type="number"                                                             
                                                name="ordem"
                                                value={this.state.statusSelecionado.ordem} 
                                                onChange={(e) => this.handleStatusChange(e, "ordem")}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3} xs={12}>
                                        <Form.Group>
                                            <Form.Label>Cor</Form.Label>
                                            <InputGroup className="mb-3">
                                                <Form.Control type="text" placeholder="Selecione a cor ao lado" name="cor" id="cor" value={this.state.statusSelecionado.cor} onChange={(e) => this.handleStatusChange(e, "cor")} 
                                                style={{width: '80%'}} />
                                                <Form.Control
                                                    type="color"
                                                    id="corInput"
                                                    name="cor"
                                                    value={this.state.statusSelecionado.cor}
                                                    title="Escolha sua cor"
                                                    onChange={(e) => this.handleStatusChange(e, "cor")}
                                                    style={{padding: 5, height: 45}}
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tipo<span style={{ color: 'red' }}> *</span></Form.Label>
                                            <Form.Control as="select" name="tipo" value={this.state.statusSelecionado.tipo} required onChange={(e) => this.handleStatusChange(e, "tipo")}>
                                                <option value="">Tipo do Status</option>
                                                <option value="normal">Normal</option>
                                                <option value="cadastro_atendimento">Cadastro de atendimento</option>
                                                <option value="cadastro_via_landing_page">Cadastro via landing page/Email</option>
                                                <option value="finalizacao_atendimento">Finalização do atendimento</option>
                                                <option value="pause_atendimento">Interrompe atendimento</option>
                                                <option value="reativacao">Reativação</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Template Whatsapp</Form.Label>
                                            <Form.Control 
                                                type="text"                                                             
                                                name="template_whatsapp"
                                                value={this.state.statusSelecionado.template_whatsapp} 
                                                onChange={(e) => this.handleStatusChange(e, "template_whatsapp")}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Descrição do Status </Form.Label>
                                            <Form.Control 
                                                as="textarea" 
                                                placeholder="Descrição" 
                                                name="descricao"
                                                value={this.state.statusSelecionado.descricao} 
                                                onChange={(e) => this.handleStatusChange(e, "descricao")} 
                                                className="custom-textarea"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Orientação</Form.Label>
                                            <Form.Control 
                                                as="textarea" 
                                                placeholder="Orientação" 
                                                name="orientacao"
                                                value={this.state.statusSelecionado.orientacao} 
                                                onChange={(e) => this.handleStatusChange(e, "orientacao")} 
                                                className="custom-textarea"
                                            />
                                        </Form.Group>
                                    </Col>

                                </Row>
                            </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleCloseModalStatus}>
                        Fechar
                    </Button>
                    <Button variant="primary" onClick={() => this.handleSalvarStatus()}>
                        Salvar
                    </Button>
                </Modal.Footer>
            </Modal>
            </>
        );
    }
}

export default StatusDoPrograma;

